import axios from 'axios';

/**
 * resolve absolute url for media files stored in Gyldendals MediaLibrary
 */
async function getAbsoluteUrlFromSrc(src) {
  if (src.includes("://")) {
    // return as is if we were already given an absolute URL
    return src;
  }
  const response = await axios.get(`${process.env["NEXT_PUBLIC__MEDIA_LIBRARY_API"]}/api/mediafiles/${src}`);
  if (!response.data) {
    return;
  }
  if (Array.isArray(response.data)) {
    return response.data.map(getMp3Url).find(it => it !== undefined);
  } else {
    return getMp3Url(response.data);
  }
}
function getMp3Url(item) {
  return item.Mp3Url;
}

export { getAbsoluteUrlFromSrc };
//# sourceMappingURL=get-absolute-url-from-src.js.map
